/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useRef} from 'react';
import classNames from "classnames";
import {useVirtualizer} from "@tanstack/react-virtual";
import styles from './ModooCarListTable.module.scss';
import {ModooCarListDataInterface, ModooCarListTableColumn} from "../ModooCarList.interface";

interface TableProps {
	data: ModooCarListDataInterface[];
}

const ModooCarListTable = ({data}: TableProps) => {
	const parentRef = useRef<HTMLDivElement>(null);

	const rowVirtualizer = useVirtualizer({
		count: data.length,
		getScrollElement: () => parentRef.current,
		estimateSize: i => 60,
		getItemKey: index => data[index].userCarId,
		overscan: 5,
	});

	const cols: ModooCarListTableColumn[] = [
		{key: 'memberSetting', title: '활동지', width: 200},
		{key: 'userCarLocation', title: '차고지', width: 80},
		{key: 'userCarType', title: '톤수', width: 100},
		{key: 'userName', title: '이름', width: 150},
		{key: 'userPhoneNum', title: '전화번호', width: 150},
		{key: 'userCarNumber', title: '차량번호', width: 150},
		{key: 'userCarWheelbase', title: '축간거리', width: 100},
	];

	const getWheelbaseStr = (wheelbase: string) => {
		if (wheelbase === 'short') return '단축';
		if (wheelbase === 'mid') return '중축';
		if (wheelbase === 'long') return '장축';
		return '';
	};

	const onClickName = (e: any, userId: string) => {
		e.preventDefault();
		e.stopPropagation();
		window.open(`/app/business/userList/${userId}`, '_blank');
	};

	return (
		<div className={styles.wrap}>
			<div ref={parentRef} className={styles.tableScrollArea}>
				{/* Sticky Header */}
				<div className={`${styles.row} ${styles.headerRow}`} style={{width: 'max-content'}}>
					{cols.map(col => (
						<div key={col.key} className={styles.cell} style={{width: col.width}}>
							{col.title}
						</div>
					))}
				</div>

				{data.length === 0
					? (
						<div className={styles.noData}>
							자료 없음
						</div>
					)
					: (
						// Virtualized Rows
						<div
							style={{
								height: `${rowVirtualizer.getTotalSize()}px`,
								position: 'relative',
								width: 'max-content',
							}}
						>
							{rowVirtualizer.getVirtualItems().map(virtualRow => {
								const record = data[virtualRow.index];

								return (
									<div
										key={record.userCarId}
										className={styles.row}
										style={{
											position: 'absolute',
											top: 0,
											left: 0,
											width: 'max-content',
											transform: `translateY(${virtualRow.start}px)`,
										}}
									>
										<div className={styles.cell} style={{width: cols[0].width}}>{record.memberSetting?.geo?.location?.address || ''}</div>
										<div className={styles.cell} style={{width: cols[1].width}}>{record.userCarLocation}</div>
										<div className={styles.cell} style={{width: cols[2].width}}>{record.userCarType}</div>
										<div
											className={classNames(styles.cell, styles.name)}
											style={{width: cols[3].width}}
											onClick={(e) => onClickName(e, record.userId)}
										>
											{record.userName}
										</div>
										<div className={styles.cell} style={{width: cols[4].width}}>{record.userPhoneNum}</div>
										<div className={styles.cell} style={{width: cols[5].width}}>{record.userCarNumber}</div>
										<div
											className={styles.cell}
										  style={{width: cols[6].width}}
										>
											{getWheelbaseStr(record.userCarWheelbase)}
										</div>
									</div>
								);
							})}
						</div>
					)}
			</div>
		</div>
	);
};


export default ModooCarListTable;
